import { CALL_API } from '../middleware/ApiMiddleware';

export const FETCH_EMAIL_TEMPLATE_LIST_REQUEST = 'FETCH_EMAIL_TEMPLATE_LIST_REQUEST';
export const FETCH_EMAIL_TEMPLATE_LIST_SUCCESS = 'FETCH_EMAIL_TEMPLATE_LIST_SUCCESS';
export const FETCH_EMAIL_TEMPLATE_LIST_FAILURE = 'FETCH_EMAIL_TEMPLATE_LIST_FAILURE';

export const FETCH_EMAIL_TEMPLATE_REQUEST = 'FETCH_EMAIL_TEMPLATE_REQUEST';
export const FETCH_EMAIL_TEMPLATE_SUCCESS = 'FETCH_EMAIL_TEMPLATE_SUCCESS';
export const FETCH_EMAIL_TEMPLATE_FAILURE = 'FETCH_EMAIL_TEMPLATE_FAILURE';

export const EDIT_EMAIL_TEMPLATE_REQUEST = 'EDIT_EMAIL_TEMPLATE_REQUEST';
export const EDIT_EMAIL_TEMPLATE_SUCCESS = 'EDIT_EMAIL_TEMPLATE_SUCCESS';
export const EDIT_EMAIL_TEMPLATE_FAILURE = 'EDIT_EMAIL_TEMPLATE_FAILURE';

export const CREATE_EMAIL_TEMPLATE_REQUEST = 'CREATE_EMAIL_TEMPLATE_REQUEST';
export const CREATE_EMAIL_TEMPLATE_SUCCESS = 'CREATE_EMAIL_TEMPLATE_SUCCESS';
export const CREATE_EMAIL_TEMPLATE_FAILURE = 'CREATE_EMAIL_TEMPLATE_FAILURE';

export const EDIT_EMAIL_TEMPLATE_SEQUENCE_REQUEST = 'EDIT_EMAIL_TEMPLATE_SEQUENCE_REQUEST';
export const EDIT_EMAIL_TEMPLATE_SEQUENCE_FAILURE = 'EDIT_EMAIL_TEMPLATE_SEQUENCE_FAILURE';
export const EDIT_EMAIL_TEMPLATE_SEQUENCE_SUCCESS = 'EDIT_EMAIL_TEMPLATE_SEQUENCE_SUCCESS';

export const RESOLVE_EMAIL_TEMPLATE_REQUEST = 'RESOLVE_EMAIL_TEMPLATE_REQUEST';
export const RESOLVE_EMAIL_TEMPLATE_FAILURE = 'RESOLVE_EMAIL_TEMPLATE_FAILURE';
export const RESOLVE_EMAIL_TEMPLATE_SUCCESS = 'RESOLVE_EMAIL_TEMPLATE_SUCCESS';

const baseURL = 'agencies/config/templates/emails';

export const fetchEmailTemplateList = () => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    authenticated: true,
    types: [FETCH_EMAIL_TEMPLATE_LIST_REQUEST, FETCH_EMAIL_TEMPLATE_LIST_SUCCESS, FETCH_EMAIL_TEMPLATE_LIST_FAILURE],
  },
});

export const fetchEmailTemplateById = (templateId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${templateId}`,
    method: 'get',
    authenticated: true,
    types: [FETCH_EMAIL_TEMPLATE_REQUEST, FETCH_EMAIL_TEMPLATE_SUCCESS, FETCH_EMAIL_TEMPLATE_FAILURE],
  },
});

export const editEmailTemplateById = (templateId: number, emailTemplateData: IEmailTemplateRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${templateId}`,
    method: 'put',
    body: emailTemplateData,
    authenticated: true,
    types: [EDIT_EMAIL_TEMPLATE_REQUEST, EDIT_EMAIL_TEMPLATE_SUCCESS, EDIT_EMAIL_TEMPLATE_FAILURE],
  },
});

export const editEmailTemplateSequence = (sequence: number[]) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/sequence`,
    method: 'put',
    authenticated: true,
    body: { sequence },
    types: [
      EDIT_EMAIL_TEMPLATE_SEQUENCE_REQUEST,
      EDIT_EMAIL_TEMPLATE_SEQUENCE_SUCCESS,
      EDIT_EMAIL_TEMPLATE_SEQUENCE_FAILURE,
    ],
  },
});

export const createEmailTemplate = (data: IEmailTemplateRequest) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'post',
    body: data,
    authenticated: true,
    types: [CREATE_EMAIL_TEMPLATE_REQUEST, CREATE_EMAIL_TEMPLATE_SUCCESS, CREATE_EMAIL_TEMPLATE_FAILURE],
  },
});

export const resolveEmailTemplate = (issueId: number, templateId: number) => ({
  [CALL_API]: {
    endpoint: `agencies/crm/${issueId}/resolve-email-template/${templateId}`,
    method: 'get',
    authenticated: true,
    types: [RESOLVE_EMAIL_TEMPLATE_REQUEST, RESOLVE_EMAIL_TEMPLATE_SUCCESS, RESOLVE_EMAIL_TEMPLATE_FAILURE],
  },
});
